import Widget from "../../../lib/ui/Widget";
import { C } from "../../../lib/ui/constructors";
var cls = C.cls;
export class ProgressBar extends Widget {
    constructor() {
        super();
        this.addClass("ctr-progress-bar");
        this.append(this.fill = cls("ctr-progress-bar-fill"));
        this.append(this.text_widget = cls("ctr-progress-bar-text"));
    }
    setProgress(progress) {
        this.fill.css("width", `${(progress * 100).toFixed(0)}%`);
        return this;
    }
    setText(text) {
        this.text_widget.text(text);
        return this;
    }
}
